<script setup>
    import { ref } from 'vue';
    import { useSpotStore } from '@/stores/SpotStore';
    import { useUserStore } from '@/stores/UserStore';
    import { useMediaQuery } from '@/composables/useMediaQuery';
    import SpotHeaderTitle from '@/components/SpotHeaderTitle.vue';
    import SpotHeaderStatusMessage from '@/components/SpotHeaderStatusMessage.vue';
    import SpotHeaderSpotMessage from '@/components/SpotHeaderSpotMessage.vue';
    import SpotHeaderPrimaryActionList from '@/components/SpotHeaderPrimaryActionList.vue';
    import ToolbarHeaderActionMenuPopup from '@/components/ToolbarHeaderActionMenuPopup.vue';
    import ModalSaveSpotToProfile from '@/components/ModalSaveSpotToProfile.vue';
    import ModalWindAlertManage from '@/components/ModalWindAlertManage.vue';
    import CloseButton from '@/components/CloseButton.vue';

    const emits = defineEmits(['close']);

    const spotStore = useSpotStore();
    const userStore = useUserStore();

    const isDesktop = useMediaQuery('(min-width: 840px)');

    const headerButtons = ['complete-report', 'favorite', 'alerts', 'widgets'];

    const showProfileModal = ref(false);
    const showManageAlertModal = ref(false);

    function handleManageAlertModalClose() {
      showManageAlertModal.value = false;
    }     

    function handleShowProfileModal() {
      showProfileModal.value = true;
    }
</script>
<template>
  <header class="jwx-map-detail-panel__header">
    <SpotHeaderTitle
      :spot="spotStore.spot"
      :isNowcastingSpot="spotStore.isNowcast"
    />

    <SpotHeaderPrimaryActionList
      v-if="isDesktop"
      @update:showProfileModal="handleShowProfileModal"
      @showAlertManageModal="showManageAlertModal = true"
      :buttons="headerButtons"
    />

    <ToolbarHeaderActionMenuPopup v-else>
      <template>
        <SpotHeaderPrimaryActionList
          @update:showProfileModal="handleShowProfileModal"
          :buttons="headerButtons"
        />
      </template>
    </ToolbarHeaderActionMenuPopup>

    <CloseButton
      class="jwx-map-detail-panel__close-button"
      @click="$emit('close')"
    />  
    
    <SpotHeaderStatusMessage :statusMessage="spotStore.statusMessage" />    

    <SpotHeaderSpotMessage :spotMessage="spotStore.spotMessage" />
  </header>

  <ModalWindAlertManage
    v-if="spotStore.spot"
    :show="showManageAlertModal"
    :spotId="spotStore.spotId"
    :spotName="spotStore.spotName"
    @close="handleManageAlertModalClose"
  />    

  <ModalSaveSpotToProfile
    v-model:showProfileModal="showProfileModal"
    v-if="showProfileModal"
    :profiles="userStore.userProfiles.profiles"
  />
</template>